import { EvalSetList } from './components/EvalSetList';
import './index.css';

const EvalSetListPage = () => {
  return <EvalSetList />;
};

export default EvalSetListPage;
